import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

export const Footer = () => {
  return (
    <footer className="bg-brand-secondary text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Column 1: Address & Contact */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Contact</h3>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-brand-primary-light mt-1 flex-shrink-0" />
                <p className="text-sm sm:text-base text-gray-200">
                  Abidjan, Cocody Angré<br />
                  Carrefour Prière
                </p>
              </div>
              <div className="flex items-center gap-3">
                <FaPhone className="text-brand-primary-light flex-shrink-0" />
                <div className="text-sm sm:text-base text-gray-200">
                  <p>07 12 65 17 19</p>
                  <p>01 00 95 95 18</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <FaEnvelope className="text-brand-primary-light flex-shrink-0" />
                <a href="mailto:contact@universitecefat.ci" className="text-sm sm:text-base text-gray-200 hover:text-white transition-colors break-all">
                  contact@universitecefat.ci
                </a>
              </div>
            </div>
          </div>

          {/* Column 2: Useful Links */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Liens Utiles</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/qui-sommes-nous" className="text-sm sm:text-base text-gray-200 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Qui sommes-nous?
                </Link>
              </li>
              <li>
                <Link to="/filieres" className="text-sm sm:text-base text-gray-200 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Nos Filières
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm sm:text-base text-gray-200 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Contact
                </Link>
              </li>
              <li>
                <a href="https://scolarite-cefat.net/preinscription" className="text-sm sm:text-base text-gray-200 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Se Préinscrire
                </a>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base text-gray-200 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Autres Établissements CEFAT
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Hours & Social */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6 text-white">Heures d'Ouverture</h3>
            <div className="flex items-start gap-3 mb-6">
              <FaClock className="text-brand-primary-light mt-1 flex-shrink-0" />
              <div className="text-sm sm:text-base text-gray-200">
                <p className="font-semibold mb-1">Lundi au Vendredi</p>
                <p className="mb-3">08h00 - 17h00</p>
                <p className="font-semibold mb-1">Samedi</p>
                <p>09h00 - 14h00</p>
              </div>
            </div>
            
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-white">Suivez-nous</h4>
            <div className="flex gap-3 sm:gap-4">
              <a 
                href="#" 
                className="bg-white/10 hover:bg-brand-primary transition-colors p-2 sm:p-3 rounded-full"
                aria-label="Facebook"
              >
                <FaFacebookF className="text-white text-sm sm:text-base" />
              </a>
              <a 
                href="#" 
                className="bg-white/10 hover:bg-brand-primary transition-colors p-2 sm:p-3 rounded-full"
                aria-label="Twitter"
              >
                <FaTwitter className="text-white text-sm sm:text-base" />
              </a>
              <a 
                href="#" 
                className="bg-white/10 hover:bg-brand-primary transition-colors p-2 sm:p-3 rounded-full"
                aria-label="Instagram"
              >
                <FaInstagram className="text-white text-sm sm:text-base" />
              </a>
              <a 
                href="#" 
                className="bg-white/10 hover:bg-brand-primary transition-colors p-2 sm:p-3 rounded-full"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn className="text-white text-sm sm:text-base" />
              </a>
              <a 
                href="#" 
                className="bg-white/10 hover:bg-brand-primary transition-colors p-2 sm:p-3 rounded-full"
                aria-label="YouTube"
              >
                <FaYoutube className="text-white text-sm sm:text-base" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 sm:pt-8">
          <div className="text-center text-gray-300 text-xs sm:text-sm">
            <p>&copy; {new Date().getFullYear()} Université CEFAT International. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};